import { Show, createMemo } from "solid-js";
import { global } from ":shared/app";
export default function VirtualLobby() {
  const $settings = global.store.hooks.platform.useSettings("virtual_lobby");
  const $link = createMemo(() => $settings().values?.url);

  return (
    <section class="flex flex-row w-full h-full <md:(px-2 py-1 !rounded-xl)">
      <Show when={$link()} fallback={<div></div>}>
        <iframe
          src={$link()}
          class="min-w-full min-h-full <md:(!rounded-xl)"
          title="YouTube video player"
          allow="microphone;camera;"
        ></iframe>
      </Show>
    </section>
  );
}
